import { useSchedule } from "../hooks/useSchedule";
import { MatchDisplay } from "./match/MatchDisplay";
import { Loading } from "./Loading";

export function ScheduleDisplay() {
  const { loading, schedule, error } = useSchedule();

  if (loading || !schedule) {
    return <Loading />;
  }

  const initialMatch = schedule.matches[schedule.matches.length - 1];

  return (
    <div className="flex w-full flex-1 flex-col items-center text-center font-black uppercase">
      <div className="w-full bg-cover bg-center bg-no-repeat py-10 md:max-w-[1980] md:gap-24 md:bg-left-top">
        <div className="flex w-full flex-col items-center justify-between gap-4 px-4">
          <MatchDisplay initialMatch={initialMatch} />
        </div>
      </div>
    </div>
  );
}
